import { apiFetch } from './client'
import type { AuthUser } from '../context/AuthContext'

export async function updateDisplayName(name: string): Promise<AuthUser> {
  const res = await apiFetch<{ data: AuthUser }>('PUT', '/api/users/me', { name })
  return res.data
}
